module.exports = __webpack_public_path__ + "templates/google-map-directive.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/google-map-directive.html
// module id = Ejyr
// module chunks = 1